import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DocumentData } from 'firebase/firestore';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import useLocales from 'hooks/useLocales';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
        height: '100%',
        display: 'flex',
        textAlign: 'left',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
}));

// ----------------------------------------------------------------------

interface TopicCardProps {
    lesson: DocumentData;
}

const LessonCard: React.FunctionComponent<TopicCardProps> = ({ lesson }) => {
    const { translate } = useLocales();
    return (
        <RootStyle>
            <CardContent
                sx={{
                    p: { md: 3 },
                    pl: { md: 5 },
                    color: 'grey.800',
                }}
            >
                <Box sx={{ flexGrow: 1 }}>
                    <Typography variant='subtitle2'>
                        {translate('lesson')} {lesson.order}
                    </Typography>
                    <Typography gutterBottom variant='h5'>
                        {lesson.title}
                    </Typography>

                    <Button variant='contained' to={lesson.id} component={RouterLink}>
                        {translate('view_lesson')}
                    </Button>
                </Box>
            </CardContent>
        </RootStyle>
    );
};

export default LessonCard;
